<template>
  <v-app>
    <v-container>
      <v-row v-if="loading || (!code && !receive_id)">
        <v-col cols="12" class="text-center">
          <p>Loading receive details...</p>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="10" offset="1">
          <v-card class="pa-4" id="receive-content">
            <v-row>
              <v-col cols="12">
                <h4 class="d-flex justify-center center" style="color: #333;"><strong>Purchase Return Details</strong></h4>
                <v-row class="justify-space-between">
                  <v-col cols="8">
                    <p style="color: #333;"><strong>SUPPLIER:</strong></p>
                    <p style="color: #555;" class="text-sub-2">{{ supplier?.name || supplier?.supplier_name || 'N/A' }}</p>
                    <p style="color: #555;" class="text-sub-2" v-if="supplier?.address || supplier?.supplier_address">
                      {{ supplier.address || supplier.supplier_address }}
                    </p>
                    <p style="color: #555;" class="text-sub-2" v-if="supplier?.mobile || supplier?.supplier_mobile">
                      <strong>Contact No:</strong> {{ supplier.mobile || supplier.supplier_mobile }}
                    </p>
                    <p style="color: #555;" class="text-sub-2" v-if="supplier?.email || supplier?.supplier_email">
                      <strong>Email:</strong> {{ supplier.email || supplier?.supplier_email }}
                    </p>
                    <p style="color: #555;" class="text-sub-2" v-if="pur_order_master?.code">
                      <strong>PO Order:</strong> {{ pur_order_master.code }}
                    </p>
                  </v-col>
                  <v-col cols="4" class="text-right">
                    <h4 style="font-weight: normal; color: #333;"><strong>RECEIVE # &nbsp;</strong>{{ code }}</h4>
                    <p style="color: #333;" class="text-sub-2" v-if="purchase_date">
                      <strong>PURCHASE DATE &nbsp;</strong>{{ formatDateView(purchase_date) }}
                    </p>
                    <p style="color: #333;" class="text-sub-2"><strong>RECEIVE DATE &nbsp;</strong>{{ formatDateView(receive_date) }}</p>
                    <p style="color: #333;" class="text-sub-2" v-if="shipping_date">
                      <strong>SHIPPING DATE &nbsp;</strong>{{ formatDateView(shipping_date) }}
                    </p>
                    <p style="color: #333;" class="text-sub-2" v-if="warehouse?.name">
                      <strong>WAREHOUSE:</strong> {{ warehouse.name }}
                    </p>
                  </v-col>
                </v-row>
                <v-row v-if="shipping_address" class="mt-2">
                  <v-col cols="12">
                    <p style="color: #555;"><strong>Shipping Address:</strong> {{ shipping_address }}</p>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="px-4">
                <br>
              </v-col>
            </v-row>
            <v-table class="mt-1" width="100%">
              <thead>
                <tr>
                  <th style="color: #333;">SN</th>
                  <th style="color: #333;">Code</th>
                  <th style="color: #333;">Item</th>
                  <th class="text-center" style="color: #333;">Quantity</th>
                  <th class="text-center" style="color: #333;">Unit</th>
                  <th class="text-center" style="color: #333;">Rate</th>
                  <th class="text-right" style="color: #333;">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(product, key) in cart" :key="product.product_id || key">
                  <td style="color: #555;">{{ key + 1 }}</td>
                  <td style="color: #555;">{{ product.product_code || '' }}</td>
                  <td style="color: #555;">{{ product.product_name || '' }}</td>
                  <td class="text-center" style="color: #555;">{{ product.qty || 0 }}</td>
                  <td class="text-center" style="color: #555;">{{ product.unit_name || '' }}</td>
                  <td class="text-center" style="color: #555;">{{ $numberFormat(product.rate || 0) }}</td>
                  <td class="text-right" style="color: #555;">{{ $numberFormat(product.total || (product.qty * product.rate) || 0) }}</td>
                </tr>
                <tr v-if="cart.length === 0">
                  <td colspan="7" class="text-center" style="color: red;">
                    No product details found
                  </td>
                </tr>
              </tbody>
            </v-table>
            <v-row class="py-10">
              <v-col cols="9">
                <p class="text-right" style="color: #555;">TOTAL AMOUNT</p>
                <v-row class="font-weight-bold justify-space-between px-3 py-4">
                  <p colspan="3" style="color: #333;"><strong>{{ convertNumberToWords(total_amount || 0) }}</strong></p>
                </v-row>
              </v-col>
              <v-col cols="3">
                <p class="text-right" style="color: #555;">{{ $numberFormat(total_amount || 0) }}</p>
              </v-col>
            </v-row>
            <v-row class="py-5" v-if="remarks">
              <v-col cols="12">
                <p style="color: #555;"><strong>Remarks:</strong> {{ remarks }}</p>
              </v-col>
            </v-row>
            <v-row class="pt-5">
              <v-col cols="4">
                <p style="border-top: 1px solid #555; width: 200px; margin: 0 auto; color: #333; text-align:center">
                  <span>Receiver's Signature</span>
                </p>
              </v-col>
              <v-col cols="4"></v-col>
              <v-col cols="4">
                <p style="border-top: 1px solid #555; width: 200px; margin: 0 auto; color: #333; text-align:center">
                  <span>{{ getCurrentCompany?.name || 'Company Name' }}</span>
                </p>
              </v-col>
            </v-row>
            <v-row class="text-center mt-6">
              <v-col cols="12">
                <v-btn color="primary" class="mr-2" @click="printReceive">
                  <v-icon left>mdi-printer</v-icon> Print
                </v-btn>
                <v-btn color="success" @click="downloadReceive(receive_id)">
                  <v-icon left>mdi-file-pdf-box</v-icon> Download PDF
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import convertNumberToWords from "@/plugins/numberToWord";
import formatDateView from "@/plugins/dateFormatView";
import { prefix } from "@/store/api";
import Axios from "axios";
import { useStore } from "vuex";
import { toast } from "vue3-toastify";

export default {
  data() {
    return {
      receive_id: '',
      code: '',
      purchase_date: '',
      receive_date: '',
      shipping_date: '',
      shipping_address: '',
      remarks: '',
      total_amount: 0,
      total_item: 0,
      supplier: {},
      warehouse: {},
      pur_order_master: {},
      cart: [],
      prefix: prefix,
      loading: false
    };
  },
  methods: {
    convertNumberToWords,
    formatDateView,

    async downloadReceive(id) {
      try {
        const response = await Axios.get(`${prefix}inventory/make-po-receive-pdf/${id}`, {
          responseType: "blob",
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `po-receive-${this.code || id}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Download failed:", error);
        toast.error("Failed to download PDF. PDF generation endpoint may not be implemented yet.");
      }
    },
    
    async printReceive() {
      let printWindow = window.open('', 'PRINT', `width=${screen.width}, height=${screen.height}, left=0, top=0`);
      printWindow.document.write(`...`); // Keep your existing print HTML
      printWindow.moveTo(0, 0);
      printWindow.focus();
      await new Promise(resolve => setTimeout(resolve, 1000));
      printWindow.print();
      printWindow.close();
    },
    
    formatNumber(value) {
      if (!value) return '0.00';
      return parseFloat(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  },
  computed: {
    getCurrentCompany() {
      return this.$store.getters.getCurrentCompany || {};
    },
    getFileServerUrl() {
      return this.$store.getters.getFileServerUrl || '';
    },
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.loading = true;
      this.$store.commit("SET_LOADING", { color: "primary" });
      this.$nextTick(() => {
        this.$store
          .dispatch("purchaseReturnDetails", { purchase_return_master_id: id })
          .then((data) => {
              this.loading = false;
              let receive = data.data.data; // Correct mapping from API

              this.receive_id = receive.id;
              this.code = receive.code || '';
              this.purchase_date = ''; // Not in API
              this.receive_date = receive.return_date || '';
              this.shipping_date = ''; // Not in API
              this.shipping_address = ''; // Not in API
              this.remarks = receive.remarks || '';
              this.total_amount = receive.amount || 0;
              this.total_item = receive.total_item || 0;

              this.supplier = receive.supplier || {};
              this.warehouse = receive.warehouse || {};
              this.pur_order_master = receive.po_receive_master_id || {}; // placeholder

              this.cart = [];
              if (Array.isArray(receive.details)) {
                  receive.details.forEach((item) => {
                      this.cart.push({
                        product_id: item.product_id,
                        product_name: item.product?.name || "",
                        product_code: item.product?.code || "",
                        qty: item.qty || 0,
                        unit_name: item.product?.unit || "",
                        rate: item.rate || 0,
                        total: item.amount || (item.qty * item.rate) || 0,
                      });
                  });
              }
              this.$store.commit("UNSET_LOADING");
          })
          .catch((error) => {
              this.loading = false;
              console.error("Failed to fetch PO receive:", error);
              toast.error("Failed to load PO receive details");
              this.$store.commit("UNSET_LOADING");
          });
      });
    } else {
      toast.error("No receive ID provided");
      this.$router.push({ name: "purchase-return-record" });
    }
  },
};
</script>
